export enum GritDynamicTableType{
  BASIC,
  EXTENDED,
  COMPLETE,
}


export enum GritDynamicTableMode{
  VIEW = 0,
  SELECT = 1,
  SELECT_ONE = 2,
  SELECT_MULTIPLE = 3
}

export enum InterferenceTestModelStates {
  Draft = "Draft",
  Approval = "Approval",
  Approved  = "Approved",
  Archived = "Archived",
  Archived_Refused  = "Archived_Refused",
  Archived_Cancelled  = "Archived_Cancelled",
  Archived_Complete   = "Archived_Complete",
}
